/* unplugin-vue-components disabled */import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  "class": "content"
};
var _hoisted_2 = {
  border: "",
  cellspacing: "0"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = ["textContent"];
var _hoisted_5 = ["textContent"];
import { standardListApi } from '@/api/international';
export default /*@__PURE__*/_defineComponent({
  __name: 'International_1',
  setup: function setup(__props) {
    var standardData = ref([{
      id: '',
      name: '',
      image: '',
      context: ''
    }]);
    onMounted(function () {
      standardListApi().then(function (res) {
        var _res$data;
        standardData.value = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : [];
      });
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("h3", null, "职能", -1)), _cache[1] || (_cache[1] = _createElementVNode("p", null, "IIFA下设标准委员会和理事会，其中标准委员会是由行业专家和会员代表组成的顾问团，负责全球职业认证标准的制定与执行事务。标准会委员每年组织两次以上全球性认证标准评估会议，针对执行标准进行评估修订。全球委员会顾问任期三年，到期后由各分部顾问委员推荐顾问接任。", -1)), _createElementVNode("table", _hoisted_2, [_createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardData), function (item) {
        return _openBlock(), _createElementBlock("tr", {
          key: item.id
        }, [_createElementVNode("td", null, [_createElementVNode("img", {
          src: item.image,
          alt: "",
          srcset: ""
        }, null, 8, _hoisted_3)]), _createElementVNode("td", null, [_createElementVNode("p", {
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_4), _createElementVNode("p", {
          textContent: _toDisplayString(item.context)
        }, null, 8, _hoisted_5)])]);
      }), 128))])])]);
    };
  }
});